var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionAltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.5C5.35786 16.5 2 13.1421 2 9C2 4.85786 5.35786 1.5 9.5 1.5C13.6421 1.5 17 4.85786 17 9C17 13.1421 13.6421 16.5 9.5 16.5ZM9.5 15C12.8137 15 15.5 12.3137 15.5 9C15.5 5.68629 12.8137 3 9.5 3C6.18629 3 3.5 5.68629 3.5 9C3.5 12.3137 6.18629 15 9.5 15ZM8.75 11.25H10.25V12.75H8.75V11.25ZM10.25 10.0163V10.5H8.75V9.375C8.75 8.96077 9.08577 8.625 9.5 8.625C10.1213 8.625 10.625 8.1213 10.625 7.5C10.625 6.87868 10.1213 6.375 9.5 6.375C8.95423 6.375 8.4992 6.76367 8.3966 7.27933L6.92548 6.9851C7.16478 5.78189 8.2265 4.875 9.5 4.875C10.9497 4.875 12.125 6.05025 12.125 7.5C12.125 8.68913 11.3343 9.6936 10.25 10.0163Z",
    fill: "#2E3031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionAltIcon);
export default __webpack_public_path__ + "static/media/question-alt-icon.eb2f243c33c80fe05d8c87f3cb8d3801.svg";
export { ForwardRef as ReactComponent };